import { createContext } from 'react';
const DocumentContext = createContext({
    document,
    scrollElement: window,
    window,
});
DocumentContext.displayName = 'DocumentContext';
export { DocumentContext, };
//# sourceMappingURL=document-context.js.map